import { formatUnits } from "viem";
import { useCurveStats } from "@/lib/curve-stats";
import { PRIVACY_CONFIG } from "@/lib/privacy-config";
import { explorerAddressUrl } from "@/lib/contracts";

function value(amount: bigint | undefined, decimals = 18, suffix = ""): string {
  if (amount === undefined) return "—";
  return `${Number(formatUnits(amount, decimals)).toLocaleString("en-US", { maximumFractionDigits: 4 })}${suffix}`;
}

function AddressRow({ label, address }: { label: string; address: string | null }) {
  return (
    <div className="quote-row">
      <span className="qr-label">{label}</span>
      <span className="qr-val mono">
        {address ? <a href={explorerAddressUrl(address)} target="_blank" rel="noreferrer">{`${address.slice(0, 8)}…${address.slice(-6)}`}</a> : "awaiting deployment"}
      </span>
    </div>
  );
}

export function InfoPanel() {
  const curve = useCurveStats();

  return (
    <section className="view active" id="view-info">
      <div className="section-head">
        <h2>Protocol</h2>
        <span className="sh-sub">live 01 market and privacy configuration</span>
      </div>

      <div className="info-kpis">
        <div className="info-kpi"><span className="v mono accent">{value(curve.spot, 18, " USDS")}</span><span className="k">curve spot price</span></div>
        <div className="info-kpi"><span className="v mono">{value(curve.reserve, 18, " USDS")}</span><span className="k">curve reserve</span></div>
        <div className="info-kpi"><span className="v mono">{value(curve.totalSupply, 18, " 01")}</span><span className="k">circulating supply</span></div>
      </div>

      <div className="cols">
        <div className="panel"><div className="panel-pad">
          <h3 className="info-h">Private pools</h3>
          <div className="quote">
            <AddressRow label="01 pool" address={PRIVACY_CONFIG.pools["01"]} />
            <AddressRow label="USD0 pool" address={PRIVACY_CONFIG.pools.usd0} />
            <AddressRow label="fee controller" address={PRIVACY_CONFIG.feeController} />
          </div>
          <p className="note-inline">Both pools use three private outputs and one shared fee controller. Retired pool addresses are excluded from this app.</p>
        </div></div>

        <div className="panel"><div className="panel-pad">
          <h3 className="info-h">USD0</h3>
          <div className="quote">
            <AddressRow label="USD0" address={PRIVACY_CONFIG.usd0} />
            <AddressRow label="USDC gateway" address={PRIVACY_CONFIG.usd0Gateway} />
          </div>
          <p className="note-inline">USD0 holder value follows the holder-owned sUSDS reserve as it grows. App mint and redeem actions route through USDC.</p>
        </div></div>
      </div>
    </section>
  );
}
